import { useMemo } from 'react';

import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';
import { useAuthContext } from 'src/context/AuthContextProvider';

export function GuestEnvironmentSelector() {
  const { auth } = useAuthContext();
  const history = useHistory();
  const { ownerId } = useParams<{ ownerId?: string }>();

  const guestUserWalletEnvironments = auth.user?.guestUserWalletEnvironments;

  const selectedEnvironment = useMemo(() => {
    return (
      guestUserWalletEnvironments
        ?.find((environment) => environment.owner.id.toString() === ownerId)
        ?.owner?.id?.toString() ?? 'my-environment'
    );
  }, [guestUserWalletEnvironments, ownerId]);

  const handleEnvironmentChange = (event: SelectChangeEvent<string>): void => {
    const newValue = event.target.value;
    history.replace(
      `/monitor${newValue === 'my-environment' ? '' : `/${newValue?.trim()}`}`,
    );
  };

  return (
    <FormControl
      sx={{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        py: 0.5,
      }}>
      <Select
        size="small"
        value={selectedEnvironment}
        onChange={handleEnvironmentChange}
        sx={{ width: 200 }}>
        <MenuItem key="my-environment" value="my-environment">
          Meu ambiente
        </MenuItem>
        {guestUserWalletEnvironments?.map((environment) => (
          <MenuItem
            key={environment.owner.id.toString()}
            value={environment.owner.id.toString()}>
            {environment.owner.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
